import { checkCompany, checkCompanyDomain } from '@/api/userManager'
export default {
  data() {
    const validateComName = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        callback(new Error('请输入企业名称'))
      }
      checkCompany({
        company_name: value
      }).then(res => {
        const { code, result } = res
        if (code === 0) {
          if (result === 'true') {
            callback()
          } else {
            callback(new Error('企业名称已存在'))
          }
        } else {
          callback(new Error('检测公司失败'))
        }
      })
    }
    const validateComDomain = (rule, value, callback) => {
      const reg = /^[A-Za-z]{1,}$/
      if (value === '') {
        callback(new Error('请输入企业域'))
      } else if (value.length > 50) {
        callback(new Error('企业域最长为50位'))
      } else if (!(reg).test(value)) {
        callback(new Error('请输入英文'))
      } else {
        checkCompanyDomain({ company_domain: value }).then(res => {
          const { code, result } = res
          if (code === 0 && result === 'true') {
            callback()
          } else {
            callback(new Error('企业域已存在'))
          }
        })
      }
    }
    const validatePassword = (rule, value, callback) => {
      const reg = /[\u4e00-\u9fa5]/
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (value.length < 6) {
        callback(new Error('密码最短为6位'))
      } else if (value.length > 20) {
        callback(new Error('密码最长为20位'))
      } else if (reg.test(value)) {
        callback(new Error('请不要使用汉字'))
      } else {
        callback()
      }
    }
    const validateRePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入确认密码'))
      } else if (value !== this.addParams.password) {
        callback(new Error('密码输入不一致'))
      } else {
        callback()
      }
    }
    const validateEditPassword = (rule, value, callback) => {
      const reg = /[\u4e00-\u9fa5]/
      if (value !== '' && value.length < 6) {
        callback(new Error('密码最短为6位'))
      } else if (value !== '' && value.length > 20) {
        callback(new Error('密码最长为20位'))
      } else if (reg.test(value)) {
        callback(new Error('请不要使用汉字'))
      } else {
        callback()
      }
    }
    const validateEditResetPassword = (rule, value, callback) => {
      if (value !== this.editParams.password) {
        callback(new Error('密码输入不一致'))
      } else {
        callback()
      }
    }
    const validateAdmin = (rule, value, callback) => {
      const reg = /^[\u4e00-\u9fa5a-zA-Z0-9]{3,15}$/
      if (value.length < 3) {
        callback(new Error('管理员账号最短为3位'))
      } else if (value.length > 15) {
        callback(new Error('管理员账号最长为15位'))
      } else if (!reg.test(value)) {
        callback(new Error('请使用中文和字母组合'))
      } else {
        callback()
      }
    }
    const validateStartDate = (rule, value, callback) => {
      this.$refs['companyInfo'].validateField('checkDate')
      callback()
    }
    const validateCheckDate = (rule, value, callback) => {
      if (this.editMode) { // 编辑
        if (!this.editParams.startDate) {
          callback(new Error('开始时间不能为空'))
        } else if (!this.editParams.endDate) {
          callback(new Error('结束时间不能为空'))
        } else if (this.editParams.startDate.getTime() === this.editParams.endDate.getTime()) {
          callback(new Error('时间不能有重合'))
        } else if (this.editParams.startDate > this.editParams.endDate) {
          callback(new Error('结束时间不能早于开始时间'))
        } else {
          callback()
        }
      } else { // 新增
        if (!this.addParams.startDate) {
          callback(new Error('开始时间不能为空'))
        } else if (!this.addParams.endDate) {
          callback(new Error('结束时间不能为空'))
        } else if (this.addParams.startDate.getTime() === this.addParams.endDate.getTime()) {
          callback(new Error('时间不能有重合'))
        } else if (this.addParams.startDate > this.addParams.endDate) {
          callback(new Error('结束时间不能早于开始时间'))
        } else {
          callback()
        }
      }
    }
    return {
      addRules: {
        companyName: [
          { required: true, validator: validateComName, trigger: 'change' }
        ],
        companyType: [
          { required: true, message: '企业类型不能为空', trigger: 'blur' }
        ],
        companyDomain: [
          { required: true, validator: validateComDomain, trigger: 'blur' }
        ],
        sellerName: [
          { required: true, message: '请输入管理员账号', trigger: 'blur' },
          { validator: validateAdmin, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        repeatPassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: validateRePassword, trigger: 'blur' }
        ],
        startDate: [
          { validator: validateStartDate, trigger: 'change' }
        ],
        checkDate: [
          { validator: validateCheckDate }
        ],
        type: [
          { required: true, message: '', trigger: 'change', type: 'number' }
        ],
        companyState: [
          { required: true, message: '12121', trigger: 'change', type: 'boolean' }
        ]
      },
      editRules: {
        password: [
          // { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validateEditPassword, trigger: 'blur' }
        ],
        resetPassword: [
          // { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: validateEditResetPassword, trigger: 'blur' }
        ],
        type: [
          { required: true, message: '', trigger: 'change', type: 'number' }
        ],
        startDate: [
          { validator: validateStartDate, trigger: 'change' }
        ],
        checkDate: [
          { validator: validateCheckDate }
        ],
        companyState: [
          { required: true, message: '12121', trigger: 'change', type: 'boolean' }
        ]
      }
    }
  }
}
